import { useTimerDownUp } from "global-components-library";
import { useState, useEffect } from "react";

const StopWatchSimultaneousPreview = ({secondsInitial,isTimeAscending,onTimeOver,timerAction, secondsDialog, status, id}) => {

  const [secondsInitialStopWatch, setSecondsInitialStopWatch] = useState(secondsInitial);
  const [stopTimerOut, setStopTimerOut] = useState(false);
  const { timeLeft , startTimer, stopTimer, clear, fullFormat, reset, setTimeLeft} = useTimerDownUp({ secondsInitial: secondsInitialStopWatch, isAscending: isTimeAscending });

  useEffect(() => {
    if(timeLeft <= 0 && !isTimeAscending)
    {
      onTimeOver()
    }
  }, [timeLeft]);
  useEffect(() => {
    if(secondsInitial !== secondsInitialStopWatch){
      setSecondsInitialStopWatch(secondsInitial)
    }
  }, [secondsInitial]);

  useEffect(() => {
    if(stopTimerOut){
      stopTimer()
      setStopTimerOut(false)
    }
  }, [stopTimerOut]);

  useEffect(() => {
    switch (timerAction) {
      case timerActions.start:
        startTimer();
        break;

      case timerActions.stop:
        stopTimer();
        break;

      case timerActions.restartFromZero:
        setSecondsInitialStopWatch(0)
        break;

      case timerActions.stopInZero:
        setSecondsInitialStopWatch(0)
        setStopTimerOut(true)
        break;

      case timerActions.restartFromInitialSecAndStart:
        setSecondsInitialStopWatch(secondsInitial);
        break;

      case timerActions.restartFromDialogAndStop:
        setTimeLeft(secondsDialog)
        setStopTimerOut(true)
        break
        
        case timerActions.restartFromDialogAndStart:
          setSecondsInitialStopWatch(secondsDialog)  
        break

      case timerActions.startByDialing:
        if(secondsDialog !== secondsInitialStopWatch)
          setSecondsInitialStopWatch(secondsDialog)
        else
          setTimeLeft(secondsDialog)
        
        break

      default:
        startTimer();
        break;

    }
  }, [timerAction]);


  return timeLeft > 0 ? fullFormat() : '00:00:00' 
};

export const timerActions = {
  "start": "start",
  "stop" : "stop",
  "restartFromZero": "restartFromZero",
  "stopInZero": "stopInZero",
  "restartFromInitialSecAndStart": "restartFromInitialSecAndStart",
  "restartFromDialogAndStop": "restartFromDialogAndStop",
  "restartFromDialogAndStart": "restartFromDialogAndStart",
  "startByDialing":"startByDialing"
};

export default StopWatchSimultaneousPreview;


// WEBPACK FOOTER //
// ./src/components/Header/StopWatch/StopWatchSimultaneousPreview.jsx